import React from 'react'

import { useAppContext } from 'context/AppContext'
import useViewport from 'hooks/useViewport'

import Header from './components/Header'
import CompareBasketMobile from '../components/CompareBasketMobile'
import Footer from '../components/Footer'
import Head from '../components/Head'

import classes from './Main.module.scss'

/** @type {import('./types').default} */
const MainLayout = ({ children }) => {
  const { head, header, url, hreflangs } = useAppContext()
  const hasHead = head && Object.keys(head).filter(key => key !== 'google_analytics').length > 0

  const { down } = useViewport()

  return (
    <>
      {hasHead && <Head metaData={head} url={url} hreflangs={hreflangs} />}
      <Header breadcrumbs={header?.breadcrumb} user={header?.user} />
      <main>
        {children}
        {down('sm') && <CompareBasketMobile />}
      </main>
      <Footer className={classes.footer} isSignedIn={!!header?.user} />
    </>
  )
}

export default MainLayout
